import React, { useEffect, useState } from 'react';
import MobileSideBar from './mobileSideBar';
import moon from './icons/moon.png'
import pressure from './icons/pressure.png'
import sunrise from './icons/sunrise.png'
import sunset from './icons/sunset.png'
import wind from './icons/wind.png'
import hydrometer from './icons/hydrometer.png'
const MainSection =({totalData})=>{
    const images = [moon,pressure,sunrise,sunset,wind,hydrometer]
    const {mainCard,sideBar}=totalData
    const [time,setTime]=useState()
    const url = `https://openweathermap.org/img/wn/${mainCard.secondaryCard[0].icon}@4x.png`
useEffect(()=>{
    startTime()
 // eslint-disable-next-line
},[])
    function startTime() {
        const today = new Date();
        let h = today.getHours();
        let m = today.getMinutes();
        let s = today.getSeconds();
        m = checkTime(m);
        s = checkTime(s);
        let NewTime = h+":"+m+":"+s
        setTime(NewTime)
        setTimeout(startTime, 1000);
      }
      
      function checkTime(i) {
        if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
        return i;
      }
    return(
      
      <section className="bg-white dark:bg-gray-900 font-poppins">
      <div className="container px-6 py-12 mx-auto">
          <div className="grid grid-cols-1  lg:grid-cols-3  ">
              <div className='text-right hidden md:block mt-20 mr-7'>  
                  <p className="mt-2 text-gray-500 dark:text-gray-400">{sideBar.sunrise}<img alt="system-Pic" className='ml-3 w-8 -mt-2 float-right' src={sunrise}/> <div className='mb-5'></div> {sideBar.sunset}<img alt="system-Pic" className='ml-3 w-8 -mt-2 float-right' src={sunset}/><div className='mb-5'></div> {time} <img alt="system-Pic" className='ml-3 w-8 -mt-2 float-right' src={moon}/></p>
              </div>
  





              <div className="container  mx-auto flex px-5 py-0 pt-10 items-center justify-center flex-col ">
    
        
        <div className="bg-cusLightBlack  flex w-80 flex-col justify-center bg-white rounded-3xl shadow-xl shadow-gray-400/20">
        <div className="p-3 text-center justify-center align-middle place-items-center">
            <h1 className="text-8xl font-poppinsBold text-gray-700 pb-2 mt-8">{mainCard.temp}<sup className=' font-poppinsLight text-2xl relative -top-12'>O</sup></h1>
           
          </div>
          <div className="aspect-video w-80 rounded-t-2xl object-cover object-center">
          <div className='justify-center align-middle place-items-center'>
            <img alt="system-Pic" className="text  leading-6 justify-center align-middle items-center ml-6 object-fill w-10/12 -mt-12" src={url} />
            </div>
          </div>
          
      
        </div>
        <div className="w-56 -mt-10 m-12 sm:ml-12 overflow-hidden bg-cusLightWhite  text-cusDarkBlack rounded-lg shadow-cusOrange drop-shadow-lg md:w-64  flex flex-col justify-center">
            <p className="py-2  text-center text-2xl ">{mainCard.secondaryCard[0].mainTitle}</p>
            
            <div className="flex items-center justify-center px-3 py-2 -mt-4 mb-2">
                <p className='text-lg text-center justify-center align-middle'> {mainCard.secondaryCard[0].description} </p>
            </div>
        </div>
      
      </div>




        <MobileSideBar data={images} shownData={sideBar} time={time}/>





       
              <div className='text-left ml-6 mt-20 hidden md:block'>              
              <p className="mt-2 text-gray-500 dark:text-gray-400">{sideBar.pressure}<img alt="system-Pic" className='mr-3 w-8 -mt-2 float-left' src={pressure}/> <div className='mb-5'></div> {sideBar.windSpeed}<img alt="system-Pic" className='mr-3 w-8 -mt-2 float-left' src={wind}/><div className='mb-5'></div> {sideBar.humidity} <img alt="system-Pic" className='mr-3 w-8 -mt-2 float-left' src={hydrometer}/></p>
              </div>
          </div>

      </div>
  </section>

    )
}
export default MainSection;